import iconAltoPng  from '../assets/nivelIncidencia/incidencia_alto.png';
import iconMedioPng from '../assets/nivelIncidencia/incidencia_medio.png';
import iconBajoPng  from '../assets/nivelIncidencia/incidencia_bajo.png';
export { iconAltoPng, iconMedioPng, iconBajoPng };

// 1-líneas para Perú (dd/mm/aa y HH:mm)
export const peDate = s => new Date(s).toLocaleDateString('es-PE', {
    timeZone: 'America/Lima', day: '2-digit', month: '2-digit', year: '2-digit', 
});
export const peTime = s => new Date(s).toLocaleTimeString('es-PE', {
    timeZone: 'America/Lima', hour: '2-digit', minute: '2-digit', hour12: true
});

export const colorMaps = {
    perimeterStroke: '#334155', // slate-700
    perimeterFill: '#e2e8f0', // slate-200
    zoneStroke: '#0ea5a4', // teal-500
    zoneFill: '#99f6e4', // teal-200
    zoneCenter: '#0f766e', // teal-600
    track: '#ef4444', // red-500
    highlight: '#f59e0b', // amber-500 (selección/hover)
};

export const nivelIncidencia = (nivel) => {
    switch (nivel) {
        case 1:
            return 'Bajo';
        case 2:
            return 'Medio';
        case 3:
            return 'Alta';
        default:
            return 'Nivel no identificado';
    }
}

export const tipoIncidencia = (tipo) => {
    switch (tipo) {
        case 1:
            return 'Accesos Vulnerados';
        case 2:
            return 'Daños a la propiedad';
        case 3:
            return 'Incendio';
        case 4:
            return 'Intrusión';
        case 5:
            return 'Otro';
        case 6:
            return 'Robo';
        default:
            return 'Tipo no identificado';
    }
}

export const estadoIncidencias = ["Reportado", "Cancelado", "En Proceso", "Resuelto"]
export const tipoIncidenciaArray = ["Accesos Vulnerados", "Daños a la propiedad", "Incendio", "Intrusión", "Otro", "Robo"]


    
export const parseApiError = (error, fallback = 'Ocurrio un problema.') => {
    if (!error) return fallback;
    const raw = typeof error === 'string' ? error : (error && error.message ? error.message : fallback);
    if (!raw) return fallback;
    const textValue = String(raw).trim();
    try {
        const parsed = JSON.parse(textValue);
        if (parsed && typeof parsed === 'object') {
            if (typeof parsed.error === 'string' && parsed.error.trim()) return parsed.error.trim();
            if (typeof parsed.message === 'string' && parsed.message.trim()) return parsed.message.trim();
        }
    } catch (_) {
        const match = textValue.match(/"error"\s*:\s*"([^"]+)"/i);
        if (match && match[1]) return match[1].trim();
    }
    return textValue || fallback;
};




